import { render } from "./QuoteLeads.vue?vue&type=template&id=1c715254"
import script from "./QuoteLeads.vue?vue&type=script&lang=js"
export * from "./QuoteLeads.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matt/Local Sites/rhinodoors_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__